import { Link, Box, Container, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import DarkModeToggle from '../common/DarkModeToggle';
import LanguageSwitcher from '../common/LanguageSwitcher';

import './customerIntake.css';

type CustomerIntakePublicShellProps = {
  children: ReactNode;
  className?: string;
  showHeaderControls?: boolean;
};

const CustomerIntakePublicShell = ({
  children,
  className = '',
  showHeaderControls = false,
}: CustomerIntakePublicShellProps) => {
  return (
    <Box className={`customer-intake-public-page ${className}`.trim()}>
      <Box component="header" className="customer-intake-public-header">
        <Container
          maxWidth="lg"
          className="customer-intake-public-header-inner"
        >
          <Box className="customer-intake-brand">
            <Box className="customer-intake-brand-mark">
              <img
                src={`${process.env.PUBLIC_URL || ''}/favicon.ico`}
                alt="Aquatics HUB logo"
              />
            </Box>
            <Box>
              <Typography className="customer-intake-brand-name">
                Aquatics HUB
              </Typography>
              <Typography className="customer-intake-brand-tagline">
                Creating a swimming culture in Hanoi
              </Typography>
            </Box>
          </Box>
          {showHeaderControls && (
            <Box className="customer-intake-public-header-actions">
              <LanguageSwitcher />
              <DarkModeToggle />
            </Box>
          )}
        </Container>
      </Box>
      <Box component="main">{children}</Box>
      <Box component="footer" className="customer-intake-public-footer">
        <Typography variant="caption">
          Aquatics HUB · Customer information registration ·{' '}
          <Link
            component={RouterLink}
            to="/customer-survey/privacy"
            underline="hover"
            color="inherit"
          >
            Personal Data Protection Policy
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default CustomerIntakePublicShell;
